import { Component, OnChanges } from '@angular/core';
import * as _ from 'lodash';

import { BaseSegmentComponent } from '../base/_base-segment.component';
import { SortableService } from 'shared/sortable/sortable.service';

@Component({
  moduleId: module.id,
  selector: 'interchange-segment',
  templateUrl: 'interchange.component.html',
  styleUrls: ['interchange.component.scss'],
  providers: [SortableService]
})
export class InterchangeComponent extends BaseSegmentComponent implements OnChanges {
  headers: any[] = [
    'part_number',
    'brand_label',
    'type_code',
    'quality_grade_level',
  ];

  ngOnChanges() {
    this.data = this.orderBy(this.data, 'sequence');
    this.setErrors();
  }

  hasNotes(item: any): boolean {
    return item.interchange_notes || item.internal_notes;
  }

  get interchanges() {
    if (this.itemDetail && this.itemDetail.interchanges) {
      return this.itemDetail.interchanges;
    } else {
      return [];
    }
  }

  set interchanges(data: any) {
    this.itemDetail.interchanges = data;
  }

  setErrors() {
    this.setItemsErrorMark(this.data, this.interchanges, 'interchanges');
  }

  hasItemError(itemName: string, index: number): boolean {
    return this.hasError(this.getErrorPath('interchanges', itemName, index));
  }

}
